import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ChakraProvider, extendTheme, Box, Container } from "@chakra-ui/react";

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Article } from "./components/article";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
    },
  },
});

const theme = extendTheme({
  styles: {
    global: {
      a: {
        color: "rgba(255, 125, 246, 0.849)",
        _hover: {
          color: "rgba(255, 190, 251, 0.849)",
          cursor: "pointer",
        },
      },
      p: {
        margin: "8px 0 8px 0",
      },
    },
  },
  colors: {
    hn: {
      text: "hsl(228, 61%, 78%)",
      background_darker: "#hsl(232, 19%, 15%)",
      background_dark: "#282c34",
      off_white: "rgb(218, 218, 218)",
      highlight: "rgba(255, 125, 246, 0.849)",
      grey: "#a6a6a6",
      wheat: "wheat",
    },
  },
});

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "article/:id",
    element: <Article />,
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ChakraProvider theme={theme}>
        <Box bgColor="hn.background_dark">
          <Container
            margin="0 auto"
            maxWidth="70em"
            minHeight="100vh"
            color="hn.text"
            padding="8"
          >
            <RouterProvider router={router} />
          </Container>
        </Box>
      </ChakraProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
